import { NgModule, LOCALE_ID } from "@angular/core";
import { registerLocaleData } from "@angular/common";
import ptBR from "@angular/common/locales/pt";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import {
    provideHttpClient,
    withInterceptorsFromDi,
} from "@angular/common/http";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { AppRoutingModule } from "./app-routing.module";
import { NgxBootstrapIconsModule, arrowRightShort } from "ngx-bootstrap-icons";
import { ToastrModule } from "ngx-toastr";

import { AppComponent } from "./app.component";
import { MainComponent } from "./main/main.component";
import { NavbarComponent } from "./components/navbar/navbar.component";
import { SafeUrlPipe } from "./pipes/safe-url.pipe";

// Config Locale
registerLocaleData(ptBR);

// NGX-Bootstrap Icons
const icons = { arrowRightShort };

@NgModule({
    declarations: [AppComponent, MainComponent, NavbarComponent, SafeUrlPipe],
    exports: [],
    bootstrap: [AppComponent],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        NgxBootstrapIconsModule.pick(icons),
        ToastrModule.forRoot(),
    ],
    providers: [
        {
            provide: LOCALE_ID,
            useValue: "pt-BR",
        },
        provideHttpClient(withInterceptorsFromDi()),
    ],
})
export class AppModule {}
